import * as PIXI from "pixi.js";

export const classicoTheme = {
  dragEvents: {
    start: "mousedown",
    move: "mousemove",
    end: "mouseup",
    endOutside: "mouseupoutside",
  },

  buildVisuals({
    m,
    node,
    textures,
    colorMode,
    editable,
    theme,
    showLabel,
    labelTexture,
  }) {
    const {
      texture,
      markerTextureLight,
      markerTextureDark,
      markerTextureTransparent,
    } = textures;

    /* -- sprite marcador -- */
    const circleTexture =
      colorMode === "light" || (m.severity == 5 && !editable)
        ? markerTextureLight
        : markerTextureDark;

    const circle = new PIXI.Sprite(circleTexture);
    const circleBase = new PIXI.Sprite(markerTextureTransparent);
    circle.tint =
      m.severity == 5 && !editable
        ? PIXI.utils.string2hex(theme.palette.color?.zabbixSeverty?.disaster)
        : 0xffffff;

    circleBase.tint = editable
      ? PIXI.utils.string2hex(theme.palette.color?.zabbixSeverty?.selected)
      : m.tint
        ? PIXI.utils.string2hex(m.tint)
        : 0xffffff;
    circle.anchor.set(0.5);
    circleBase.anchor.set(0.5);

    /* -- sprite ícone -- */
    const sprite = new PIXI.Sprite(texture);

    // Lida com mudança da cor do icone no modo claro e escuro
    // Altera apenas SVG, para não alterar icones PNG com cores adicionados pelo usuário
    if (texture.baseTexture?.resource?.src?.includes("svg"))
      sprite.tint =
        colorMode === "dark" || m.severity == 5 ? "#e6e6e6" : "#202020ff";
    sprite.anchor.set(0.5);
    sprite.width = 42;
    sprite.height = 42;
    sprite.baseScale = sprite.scale.clone();

    node.zIndex = 100;
    node.addChild(circle);
    node.addChild(circleBase);
    node.addChild(sprite);

    if (showLabel) {
      const titleSprite = new PIXI.Sprite(labelTexture);
      titleSprite.anchor.set(0.5);
      titleSprite.y = -55;
      node.addChild(titleSprite);
    }
    return {
      spriteRefs: { circle, circleBase, sprite },
    };
  },

  buildExplosion({ m, editable, configElementDataMap }) {
    const configEl = configElementDataMap?.get(m.id);
    if (!(configEl?.severity > 1 && !editable)) return null;

    const explosion = new PIXI.Graphics();
    explosion.beginFill(m.tint, 0.9);
    explosion.drawCircle(0, 0, 32);
    explosion.endFill();
    explosion.alpha = 0.001;
    return explosion;
  },
};
